import {apolloClient} from '@/setup/apollo-setup';
// import axios from "axios";
import axios from "@/setup/axios-setup";
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {config} from "@/utils/upload";
import {
  GET_CLASSMATERIAL,
  GET_CLASSMATERIALS,
  GET_CLASSMATERIALS_BY_FILTER,
  ADD_CLASSMATERIAL,
  UPDATE_CLASSMATERIAL,
  DELETE_CLASSMATERIAL
} from '@/queries/modules/courses/class-material';

export async function getClassMaterials(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSMATERIALS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassMaterials', data.getClassMaterials);
      context.commit('setSuccess', null);
      return data.getClassMaterials
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassMaterialsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSMATERIALS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setClassMaterials', data.getClassMaterialsByFilter);
      context.commit('setSuccess', null);

      return data.getClassMaterialsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getClassMaterial(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_CLASSMATERIAL,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setClassMaterial', data.getClassMaterial);
      context.commit('setSuccess', null);
      return data.getClassMaterial
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addClassMaterial(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_CLASSMATERIAL,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const classMaterials = [...context.state.classMaterials];
      classMaterials.push(data.addClassMaterial);
      context.commit('setClassMaterials', classMaterials);
      context.commit('setSuccess', newItemSuccess(data.addClassMaterial.nameLocal));

      return data.addClassMaterial;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateClassMaterial(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_CLASSMATERIAL,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.classMaterials.findIndex(item => item.id === data.updateClassMaterial.id);
      const classMaterials = [
        ...context.state.classMaterials.slice(0, index),
        data.updateClassMaterial,
        ...context.state.classMaterials.slice(index + 1)
      ];
      context.commit('setClassMaterials', classMaterials);
      context.commit('setSuccess', updateItemSuccess(data.updateClassMaterial.nameLocal));

      return data.updateClassMaterial
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteClassMaterial(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_CLASSMATERIAL,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.classMaterials.findIndex(item => item.id === data.deleteClassMaterial.id);
      const classMaterials = [
        ...context.state.classMaterials.slice(0, index),
        ...context.state.classMaterials.slice(index + 1)
      ];
      context.commit('setClassMaterials', classMaterials);
      context.commit('setSuccess', deleteItemSuccess(data.deleteClassMaterial.nameLocal));

      return data.deleteClassMaterial
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function uploadMaterial(context, payload){
  const rsc = JSON.parse(localStorage.getItem("rsc"));
  let entity, stage
  if (rsc) {
    entity = rsc.e_code;
    stage = rsc.r_stage;
  }


  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('file1', payload.file1);
  formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
  formData.append('timestamp', payload.file.lastModified);
  formData.append('operationName', payload.operationName);
  // formData.append('stage', payload.stage);
  // formData.append('entity', payload.entity);
  formData.append('stage', stage);
  formData.append('entity', entity);
  formData.append('authorization', payload.authorization);
  formData.append('app', payload.app);

  try {
    const result = await axios({
      url: config.url.uploadFiles,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: formData,
    });


    const {data} = await result;

    return data;
  } catch (e) {
    // commit('setError', error(e));
    return null;
  }

}

